export default __webpack_public_path__ + "static/media/logo1.cb7501aa.svg";